import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ROUTE_PATH,
  APPLICATION_MODE_NEW,
  DOCUMENT_TYPE_INSURANCE_PROOF,
  individualFileSizeAllowedInMB,
  DOCUMENT_CONTENT_TYPE_PDF,
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
  REQUEST_STATUS
} from "../../app/constants";
import {
  Header,
  Paragraph,
  Button,
  ErrorMark,
  NavigationLinkButton,
} from "../../components/RegularComponents";

// import CheckboxForm from "../../components/CheckBoxForm";
import TopNavigationBar from "../TopNavigationBar";
import { ERROR_STRING } from "../../app/errors";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { 
  acceptedFileFormats,
  convertFileDataForUrl,
  extractBase64, 
  fileNameWithLengthLimit, 
  fileTypeEnum, 
  validateFileName
} from "../../app/documentUploadUtils";
import { fetchDocumentData } from "../../redux/slice/supportingDocumentsSlice";
import { DocumentViewerFileNameLink, DownloadFileNameLink } from "../../components/DocumentViewer/DocumentFileComponent";
import DocumentViewer from "../../components/DocumentViewer/DocumentViewer";
import { addMortgageBrokerageInsuranceDocuments } from "../../redux/slice/primaryAgencyApplicationSlice";

export const UploadProofOfInsurance = (props) => {

  const insuranceProofSelect = useSelector(
    (state) =>
      {
        let insuranceDocument = []

        if(state.primaryAgencyApplication.application?.documents) {
          insuranceDocument = state.primaryAgencyApplication.application?.documents.filter(docs => (docs.documentType === DOCUMENT_TYPE_INSURANCE_PROOF 
            && docs.changeType !== "DELETE"))
        }

        return insuranceDocument
      }
  );

  const serverSaveRequest = useSelector(state => state.primaryAgencyApplication.serverRequestStatus)
  
  const dispatch = useDispatch();
  const applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE;
  const applicationMode = APPLICATION_MODE_NEW;
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  const [showValidationError, setShowValidationError] = useState(false);
  const [proofOfInsuranceFile, setProofOfInsuranceFile] = useState(insuranceProofSelect.length > 0 ? insuranceProofSelect[0] : {});

  const [openDocumentViewer, setOpenDocumentViewer] = useState(false)
  const [documentViewerDocument, setDocumentViewerDocument] = useState(null)
  
  const { isModal = false, onEditSave = () => {} } = props;

  const handleSaveAndNext = () => {
    setApplicationSaveError(false);
    setShowValidationError(false);

    // Set MORTGAGE PROP to uploaded file
    // dispatch(
    //   setMortgageProperty({
    //     key: MORTGAGE_APPLICATION_PROPERTY,
    //     value: proofOfInsuranceFile,
    //   })
    // );

    if(!proofOfInsuranceFile || Object.keys(proofOfInsuranceFile).length === 0) { 
      setShowValidationError(true)
      return
    }

    dispatch(addMortgageBrokerageInsuranceDocuments(proofOfInsuranceFile))

    // On to the next item
    dispatch(
      saveBusinessLicenceApplicationData(applicationType, applicationMode)
    )
      .then((data) => {
        dispatch(
          !isModal
            ? push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_BROKER_CONFIRMATION}`)
            : onEditSave()
        );
      })
      .catch((err) => {
        setApplicationSaveError(true);
      });
  };

  const fileSizeReplacement = (string, fileSize) => { 
    const replaceRegExp = /<file_size>/g 
    const errorString = string.replace(replaceRegExp,(fileSize + "MB"))
    return errorString
  }

  const handleFileInput = (e) => {
    if (e.target.files.length > 0) {
      let file = e.target.files[0];
      
      // individual file size can not be more than 15 MB
      if(file.size > (individualFileSizeAllowedInMB * (2 ** 20))) { 
        alert(fileSizeReplacement(ERROR_STRING.SUPPORTING_DOC_VERY_LARGE_INDIVIDUAL_FILE,individualFileSizeAllowedInMB))
        return
      } else if(!validateFileName(file.name)) {
        alert("File name is not valid. Please select another file.")
        return
      }

      let reader = new FileReader();
      reader.onload = (readerData) => {
        setProofOfInsuranceFile({
          filename: fileNameWithLengthLimit(file.name),
          documentContentType: fileTypeEnum(file.type),
          data: extractBase64(readerData.target.result),
          changeType: "SAVE",
          documentType: DOCUMENT_TYPE_INSURANCE_PROOF,
          fileSize : file.size
        });
      };
      reader.readAsDataURL(file);

      // set proper file check here
      // reset validation errors
      setShowValidationError(false);
    }
  };

  const fileComponent = () => {
    const file = proofOfInsuranceFile
    return (
      <>
          <div className="supportingDocumentsFileContentWrapper">
              <span className="fileName">
                  {file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF ? 
                      <DocumentViewerFileNameLink
                          id={"proof-of-insurance-file-" + file.filename}
                          key={"proof-of-insurance-file-" + file.filename}
                          file={file}
                          onClick={() => { 
                              if(file.data) { 
                                  let fileDataUrl = convertFileDataForUrl(file.data, file.documentContentType)
                                  setDocumentViewerDocument(fileDataUrl)
                                  setOpenDocumentViewer(true)
                              } else { 
                                  // download data and then view it.
                                  if(file.guid) { 
                                      dispatch(fetchDocumentData(file.guid))
                                          .then(downloadFile => {
                                              if(downloadFile) { 
                                                  let fileDataUrl = convertFileDataForUrl(downloadFile.data, downloadFile.documentContentType)
                                                  setDocumentViewerDocument(fileDataUrl)
                                                  setOpenDocumentViewer(true)
                                              }
                                          })
                                          .catch((error) => {
                                              console.error(error)
                                          })
                                  }
                              }
                          }}
                      /> : 
                      <DownloadFileNameLink
                          id={"proof-of-insurance-file-" + file.filename}
                          componentKey={"proof-of-insurance-file-" + file.filename}
                          file={file} 
                      />
                  }
              </span>
              
              <NavigationLinkButton
                  id={"proof-of-insurance-file-remove-link"}
                  text={"- Remove this file"}
                  onClick={() => {
                    setProofOfInsuranceFile({})
                  }}
              />
          </div>
      </>
  )
  }


  return (
    <>
      <div className={!isModal ? "container" : ""}>
        {!isModal && (
          <>
            <TopNavigationBar {...props} />
            <div className="row">
              <div className="col-xs-12 col-lg-9">
                <Header
                  style={{ paddingBottom: "20px" }}
                  id="upload-proof-of-insurance-header"
                  header="Upload proof of Errors and Omissions Insurance"
                />
                <Paragraph
                  id="upload-proof-of-insurance-text"
                  text={[
                    "To obtain a mortgage brokerage licence in Nova Scotia, your company must have Errors and Omissions insurance (E&O) at all times while your licence is in force. The insurance must provide extended coverage for loss resulting from fraudulent acts.",
                  ]}
                />
                <Paragraph
                  id="upload-proof-of-insurance-text"
                  text={[
                    "You need enough insurance to cover at least:",
                    `<ul>
                      <li><b>$500,000</b> in respect of any 1 occurance involving the licensee, including, for a mortgage brokerage, any mortgage broker or associate mortgage broker authorized to broker mortgages on its behalf.</li>
                      <li><b>$1,000,000</b> to cover all claims in a 365 day period involving the licensee, including, for a mortgage brokerage, any mortgage broker or associate mortgage broker authorized to broker mortgages on its behalf.</li>
                    </ul>`,
                  ]}
                />
                <Paragraph
                  id="upload-proof-of-insurance-text"
                  text={[
                    "Proof - a copy of the Certificate or Insurance stating the coverage provided including extended coverage for loss resulting from fraudulent acts as proof.",
                  ]}
                />
              </div>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-xs-12 col-lg-8">
            {(proofOfInsuranceFile && Object.keys(proofOfInsuranceFile).length > 0) &&
            fileComponent()}
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-8">
            <fieldset className="ns-fieldset" id="criminal-records-form">
              <div className={"ns-fieldset"}>
                <label
                  className="ns-label"
                  id="upload-proof-of-insurance-file-label"
                  htmlFor="upload-proof-of-insurance-file-input"
                >
                  Upload a file
                </label>
                <div className="ns-file-input">
                  <input
                    disabled={(proofOfInsuranceFile && Object.keys(proofOfInsuranceFile).length > 0)}
                    className="ns-input"
                    style={{width: "15em", display: "inline"}}
                    type="file"
                    value=""
                    accept={acceptedFileFormats(DOCUMENT_TYPE_INSURANCE_PROOF).join(',')}
                    id="upload-proof-of-insurance-file-input"
                    name="upload-proof-of-insurance-file-input"
                    multiple={false}
                    onInput={handleFileInput}
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Paragraph
              style={{ paddingBottom: "20px" }}
              id="upload-proof-of-insurance"
              text={[
                "The maximum file size allowed is 15 MB per file and 50 MB total. Supported document types are Microsoft Word, Microsoft Office Excel, or Adobe PDF.  All digital files must be in an uncompressed format, i.e no zip or ARC files.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div
            className={"col-lg-4" + (showValidationError ? " has-error" : "")}
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={!isModal ? "Save and next" : "Save and close"}
              onClick={handleSaveAndNext}
              showSpinner={!applicationSaveError && 
                (serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
              disabled={(serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
            />
            {applicationSaveError && !isModal && ErrorMark()}
            {applicationSaveError && !isModal && (
              <div className="ns-error-message help-block topMarginNormal">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
            {showValidationError && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.UPLOAD_CERTIFICATE_ERROR}
              </div>
            )}
          </div>
        </div>

        <DocumentViewer 
            fileData={documentViewerDocument}
            isOpen={openDocumentViewer}
            fileName={proofOfInsuranceFile?.filename}
            handleClose={() => setOpenDocumentViewer(false)}
        />

      </div>
    </>
  );
};
